var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2812_11325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4206 33.9328L31.0331 6.30469C28.0893 1.33594 20.9081 1.33594 17.9549 6.30469L1.5768 33.9328C-1.43257 38.9953 2.22368 45.4078 8.11118 45.4078H40.8862C46.7737 45.4078 50.4299 38.9953 47.4206 33.9328ZM24.4987 39.2953C22.5581 39.2953 20.9831 37.7203 20.9831 35.7797C20.9831 33.8391 22.5581 32.2641 24.4987 32.2641C26.4393 32.2641 28.0143 33.8391 28.0143 35.7797C28.0143 37.7203 26.4393 39.2953 24.4987 39.2953ZM28.1081 16.9172L27.6768 27.0797C27.6018 28.8328 26.1206 30.1922 24.3674 30.1172C22.7174 30.0516 21.3956 28.7297 21.3299 27.0797L20.8987 16.9172C20.7956 14.9203 22.3331 13.2234 24.3206 13.1203C26.3174 13.0172 28.0143 14.5547 28.1174 16.5422C28.1174 16.6734 28.1174 16.7953 28.1081 16.9172Z",
    fill: "#FD4760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2812_11325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.f693f4a75e92b57d75b6ab2f8f00f088.svg";
export { ForwardRef as ReactComponent };